export let CrmExperienceOption;

(function (CrmExperienceOption) {
  CrmExperienceOption["None"] = "none";
  CrmExperienceOption["HasUsedCrm"] = "has_used_crm";
  CrmExperienceOption["HasUsedHubSpot"] = "has_used_hubspot";
})(CrmExperienceOption || (CrmExperienceOption = {}));